/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { globalServices } from "../../../Services/global.service";
import { storeService } from "../../../Services/store.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Tooltip from "../../../Components/Common/Tooltip";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import DatePicker, { registerLocale } from "react-datepicker";
import * as dateHelper from "../../../Helpers/DateHelper";
import ReportDetail from "./Details";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import AsyncSelect from "react-select/async";
import XLSX from "xlsx";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

registerLocale("hr", hr);
registerLocale("en", en);

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    //defaultValues: { reports },
  });
  const { userId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [posId, setPosId] = useState([]);
  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    date: new Date(),
  });
  const [obj, setObj] = useState({
    guid: "",
    amount: 0,
    docNumber: "",
    invoiceDocNumberFrom: 0,
    invoiceDocNumberTo: 0,
    year: 0,
    isShow: false,
  });

  let reportId = [];

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    storeId: 0,
    posId: 0,
    IssuedTime: "",
    searchText: "",
  });
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  useEffect(() => {
    updateLocName("invoices-conclusion-report");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosId(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };

  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);
    reportService
      .invoicesConclusionView({
        tenantId: Number(search.tenantId),
        storeId: Number(search.storeId),
        posId: Number(search.posId),
        fromIssuedTime: search.validFrom,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setReports(res.data.data);
        setPagination({
          ...pagination,
          totalCount: res.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    reportId = [];
    document.getElementById("actions").style.display = "none";
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        rowEvents={rowEvents}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          totalSize,
          hideSizePerPage: true,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );
  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  function dateFormatter(cell) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(row?.created),
    }).format(Number(cell));
  }
  const columns = [
    {
      dataField: "date",
      text: translator("Report-View-TableHeader-Date"),
      headerStyle: (colum, colIndex) => {
        return { textAlign: "left" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "created",
      text: translator("Report-View-TableHeader-DateTime"),
      headerStyle: (colum, colIndex) => {
        return { textAlign: "left" };
      },
      formatter: dateTimeFormatter,
    },
    {
      dataField: "storeTag",
      text: translator("Report-View-TableHeader-StoreTag"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "posTag",
      text: translator("Report-View-TableHeader-PosTag"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "invoiceDocNumberFrom",
      text: translator("Report-View-TableHeader-DocNumberFrom"),
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "left" };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "invoiceDocNumberTo",
      text: translator("Report-View-TableHeader-DocNumberTo"),
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "left" };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-PayValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setObj({
        isShow: true,
        guid: row.invoiceConclusionGuid,
        amount: row.amount,
        docNumber: row.documentNumber,
        year: row.year,
        invoiceDocNumberFrom: row.invoiceDocNumberFrom,
        invoiceDocNumberTo: row.invoiceDocNumberTo,
        created: row.created,
      });
    },
  };

  const handleClose = () => {
    setObj({ ...obj, isShow: false });
  };

  const exportExcelFunction = () => {
    reportService
      .invoicesConclusionView({
        tenantId: Number(search.tenantId),
        storeId: Number(search.storeId),
        posId: Number(search.posId),
        fromIssuedTime: search.validFrom,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        // File name
        var ws_name = `${translator("InvConclusionCashBalance-Title")}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), reportTag.tenantName],
          [
            translator("InvoiceCashBalancePDF-Date"),
            dateFormatter(search.validFrom),
          ],
          [
            translator("Report-View-TableHeader-DateTime"),
            translator("Report-View-TableHeader-StoreTag"),
            translator("Report-View-TableHeader-PosTag"),
            translator("Report-View-TableHeader-DocNumberFrom"),
            translator("Report-View-TableHeader-DocNumberTo"),
            translator("Report-View-TableHeader-PayValue"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res.data.data.map((x) => {
          const array = [
            dateTimeFormatter(x.created),
            x.storeTag,
            x.posTag,
            x.invoiceDocNumberFrom,
            x.invoiceDocNumberTo,
            x.amount,
          ];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        console.log(ws);
        ws["!cols"] = [
          { width: 22 },
          { width: 15 },
          { width: 12 },
          { width: 14 },
          { width: 14 },
          { width: 18 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, ws_name);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("InvConclusionCashBalance-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeId", null);
                        setValue("posId", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });
                        getStores(event[0].id);
                        //setReports([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                    <Tooltip text={translator("StoreTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="storeId"
                      rules={{ required: true }}
                      onChange={function (event) {
                        setValue("posId", null);
                        setSearch({
                          ...search,
                          storeId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          storeName: event[0].label,
                        });
                        getPos(event[0].id);
                        //setReports([]);

                        return event[0];
                      }}
                      options={
                        storesTag &&
                        storesTag.map((e) => ({
                          id: e.id,
                          label: e.tag,
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.storeId && (
                      <>
                        {errors.storeId.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                    <Tooltip text={translator("PosTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      name="posId"
                      placeholder={translator("SelectStoreTag")}
                      rules={{ required: true }}
                      onChange={function (event) {
                        setSearch({
                          ...search,
                          posId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          posName: event[0].label,
                        });
                        //setReports([]);

                        return event[0];
                      }}
                      options={
                        posId &&
                        posId.map((e) => ({
                          id: e.posid,
                          label: e.tag + " - ( " + e.inventoryNumber+" )",
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.posId && (
                      <>
                        {errors.posId.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidOnDay")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        maxDate={
                          search && search.validTo && new Date(search.validTo)
                        }
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="validFrom"
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "validFrom",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          //setReports([]);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.validFrom &&
                      errors.validFrom.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                  </div>
                </>
              }

              {
                <>
                  <div
                    style={{ marginTop: "-28px" }}
                    className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12"
                  >
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <button
              className="btn btn-outline-secondary"
              onClick={exportExcelFunction}
            >
              <i className="fas fa-file-alt"></i>{" "}
              {translator("Reports-PrintExclBtn")}
            </button>
          ) : (
            ""
          )}
        </div>
        <Modal show={obj.isShow} backdrop="static" keyboard={false} size={"xl"}>
          <Modal.Body>
            <ReportDetail obj={obj} tags={reportTag} />
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={handleClose}
              type="button"
              className="btn btn-outline-secondary"
            >
              {translator("General-Close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Table;
